import './index.scss'
$(".section1 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text .answer").slideToggle();
})